export default __webpack_public_path__ + "static/media/providers.815e1bd4.svg";